module.exports = __webpack_public_path__ + "static/img/photo_2023-10-30_14-59-27.fd232e59.jpg";